import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Button, Input, Checkbox, message } from "antd";
import { postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { initialPermissions } from "../../../utils/UtilService";

const CreateRoles = ({ onOpen, onClose, fetchRoles, onSave, onSucessFail }) => {
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [permissions, setPermissions] = useState(initialPermissions);

  const [errorMessage, setErrorMessage] = useState({
    roleName: "",
    description: "",
  });

  const handleCheckboxChange = (permission, type) => {
    setPermissions((prev) => ({
      ...prev,
      [permission]: {
        ...prev[permission],
        [type]: !prev[permission]?.[type],
      },
    }));
  };

 const handleCreate = async () => {
  let isValid = true;
  const errors = { roleName: "", description: "" };

  if (!roleName.trim()) {
    errors.roleName = "Role Name is required";
    isValid = false;
  }

  if (!description.trim()) {
    errors.description = "Description is required";
    isValid = false;
  }

  setErrorMessage(errors);
  if (!isValid) return;

  const formattedPermissions = Object.entries(permissions).map(
    ([resource_name, perms]) => ({
      resource_name,
      view: perms.view || false,
      edit: perms.edit || false,
    })
  );

  try {
    // ✅ safely capture any axios error response
    const res = await postApi({
      apiUrl: API_URLS.CREATE_ROLE,
      data: {
        name: roleName,
        description,
        permissions: formattedPermissions,
      },
    }).catch((error) => {
      // if axios throws, catch here and convert into response-like object
      return error.response?.data || {
        success: false,
        message: error.message || "Network error",
      };
    });

    // ✅ Now you can rely on res.success
    if (res.success) {
      fetchRoles();
      onSave();
      onClose();
    } else {
      onSucessFail();
      // onClose();
      // message.error(res.message || "Failed to create role");
    }
  } catch (err) {
    // This will only run if something catastrophic happens (e.g., runtime error)
    console.error("Unexpected error:", err);
    message.error("Something went wrong while creating role");
  }
};


  const handleCancel = () => {
    setRoleName("");
    setDescription("");
    setPermissions({});
    setErrorMessage({ roleName: "", description: "" });
    onClose();
  };

  const permissionKeys = Object.keys(permissions);

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      <div>
        <h3 className="text-xl font-bold text-[#06513D]">Create Role</h3>
        {/* <div className="w-1/3 h-1 bg-gradient-to-r from-blue-500 to-teal-600 mt-2" /> */}
      </div>

      <div className="mt-8">
        <div className="flex flex-col gap-6 ">
          <Input
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            placeholder="Role Name"
            className="text-base font-light h-14 rounded-lg"
          />
          {errorMessage.roleName && (
            <div className="text-red-500 text-sm">{errorMessage.roleName}</div>
          )}

          <Input
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
            className="text-base font-light h-14 rounded-lg"
          />
          {errorMessage.description && (
            <div className="text-red-500 text-sm">
              {errorMessage.description}
            </div>
          )}
        </div>

        <div className="mt-8 border rounded-lg px-10 py-6">
          <div className="flex justify-between font-light text-[#A2A1A8] text-base">
            <div>Permissions</div>
            <div className="flex gap-x-8">
              <div>View</div>
              <div>Edit</div>
            </div>
          </div>

          {permissionKeys.map((permission) => (
            <div key={permission} className="flex justify-between mt-4">
              <div className="text-base font-medium">{permission}</div>
              <div className="flex gap-x-12">
                <Checkbox
                  checked={permissions[permission]?.view || false}
                  onChange={() => handleCheckboxChange(permission, "view")}
                />
                <Checkbox
                  checked={permissions[permission]?.edit || false}
                  onChange={() => handleCheckboxChange(permission, "edit")}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center gap-6 p-5">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={handleCancel}
            className="text-base font-normal h-[50px] w-[160px]"
          />

          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText="Save"
            onClick={handleCreate}
            className="text-base font-normal h-[50px] w-[160px]"
          />
        </div>
      </div>
    </DailogBox>
  );
};

export default CreateRoles;
